<div id="lista" class="page-layout carded fullwidth">

    <!-- TOP BACKGROUND -->
    <div class="top-bg accent"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center">

        <!-- HEADER -->
        <div 
            class="header accent"
            fxLayout="column" 
            fxLayoutAlign="center center"
            fxLayout.gt-sm="row" 
            fxLayoutAlign.gt-sm="space-between center"
        >

            <!-- APP TITLE -->

            <div fxLayout="column" fxLayoutAlign="center start">
                <div fxLayout="row" fxLayoutAlign="start center">
                    <mat-icon class="secondary-text s-18">home</mat-icon>
                    <mat-icon class="secondary-text s-16">chevron_right</mat-icon>
                    <span class="secondary-text pointer" style="cursor: pointer;" (click)="retornarLista()">Lista de Baskets</span>
                </div>
                <div class="h1 mt-16">{{titulo}}</div>
            </div>
            <!-- / APP TITLE -->

            <div class="add-product-button mb-24 mb-md-0" fxLayout="row" fxLayoutAlign="start center">
                <!-- ADD BUTTON -->
            <button mat-raised-button mat-icon-button [matMenuTriggerFor]="animals">
                <mat-icon>settings_applications</mat-icon>
            </button>
            <!-- / ADD BUTTON -->
            <mat-menu #animals="matMenu">
                <button mat-menu-item (click)="openFiltro()">
                    <mat-icon>search</mat-icon>
                    CONSULTAR
                </button>
            </mat-menu>
        </div>
           
        </div>
        <!-- / HEADER -->

        <!-- CONTENT CARD -->
        <div class="content-card">
            <ngx-datatable 
                #table 
                class='material' 
                [loadingIndicator]="loadingIndicator"
                [columns]="columns" 
                [columnMode]="'force'" 
                [headerHeight]="50"                       
                [footerHeight]="50" 
                [rowHeight]="'auto'" 
                [rows]='rows'>

                <ngx-datatable-column name="Cliente" prop="clientes" [sortable]="false" [width]="300" >
                    <ng-template let-rowIndex="rowIndex" let-clientes="value" ngx-datatable-cell-template>
                        {{clientes.numero_xp}} - {{clientes.nome}}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Quantidade" prop="qtd" [sortable]="false">
                    <ng-template let-rowIndex="rowIndex" let-qtd="value" ngx-datatable-cell-template>
                        {{ qtd | number : '1.0-0' }}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Papel" prop="sigla_ativo" [sortable]="false">
                    <ng-template let-rowIndex="rowIndex" let-sigla_ativo="value" ngx-datatable-cell-template>
                        {{ sigla_ativo }}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Operação" prop="operacao" [sortable]="false">
                    <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                        <span [ngClass]="{'negativo': getOperacao(row) == 'V', 'positivo': getOperacao(row) == 'C' }">
                            {{ getOperacao(row) }}
                        </span>
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Estratégia" prop="estrategia" [sortable]="false">
                    <ng-template let-rowIndex="rowIndex" let-estrategia="value" ngx-datatable-cell-template>
                        {{ estrategia }}
                    </ng-template>
                </ngx-datatable-column>
                
                <ngx-datatable-column name="Preço" prop="preco" [sortable]="false">
                    <ng-template let-rowIndex="rowIndex" let-preco="value" ngx-datatable-cell-template>
                        {{ preco | number : '1.2-2' }}
                    </ng-template>
                </ngx-datatable-column> 

                <ngx-datatable-column name="Validade Ordem" prop="validade_ordem" [sortable]="false">
                    <ng-template let-rowIndex="rowIndex" let-validade_ordem="value" ngx-datatable-cell-template>
                        {{ validade_ordem }}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Validade Push" prop="validade_push" [sortable]="false">
                    <ng-template let-rowIndex="rowIndex" let-validade_push="value" ngx-datatable-cell-template>
                        {{ validade_push }}
                    </ng-template>
                </ngx-datatable-column>                

                
            </ngx-datatable>

            <div style="padding: 5px 10px">
                <mat-paginator 
                    #paginator 
                    [length]="length"
                    [pageSize]="pageSize"
                    [pageSizeOptions]="pageSizeOptions"
                    (page)="pageEvent($event)">
                </mat-paginator>
            </div>
        </div>
    </div>
</div>